import React, { useEffect, useMemo } from "react";
import { Script } from "gatsby";
import { useColorMode } from "@chakra-ui/react";

export const FeedbackGiscus: React.FC = () => {
  const { colorMode } = useColorMode();
  const giscusTheme = colorMode === "light" ? "light" : "dark_dimmed";

  const scriptId = useMemo(() => Math.random().toString(), []);

  useEffect(() => {
    const iframe = document.querySelector(
      "iframe.giscus-frame"
    ) as HTMLIFrameElement | null;
    if (!iframe) return;
    iframe.contentWindow?.postMessage(
      {
        giscus: {
          setConfig: {
            theme: giscusTheme,
          },
        },
      },
      "https://giscus.app"
    );
  }, [colorMode, giscusTheme]);

  return (
    <div>
      <div className="giscus"></div>
      <Script
        id={scriptId}
        src="https://giscus.app/client.js"
        data-repo="apollographql-education/content-feedback"
        data-repo-id="R_kgDOIuBSYQ"
        data-category="course feedback"
        data-category-id="DIC_kwDOIuBSYc4CTZiM"
        data-mapping="pathname"
        data-strict="0"
        data-reactions-enabled="0"
        data-emit-metadata="0"
        data-input-position="bottom"
        data-theme={giscusTheme}
        data-lang="en"
        crossOrigin="anonymous"
        async
      />
    </div>
  );
};
